export const convertUpdateItemPriceDataToForm = (price: {
  [key: string]: number;
}): { [key: string]: number }[] => {
  return Object.keys(price ?? {}).map((key) => ({ [key]: price[key] }));
};

export const convertFormPriceDataToDto = (
  price: {
    [key: string]: number;
  }[]
): { [key: string]: number } => {
  return price?.reduce((initial, cur) => {
    const currentItemKey = Object.keys(cur)[0];
    return { ...initial, [currentItemKey?.toLowerCase()]: cur[currentItemKey] };
  }, {});
};
